import React, {useState, useContext} from "react";
import { Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import { Header } from "../components/Header";

import "../css/general.css";
import "./GreetingWindow.css";
import "../auth/Login.css";

import api from "../../js/utils/async/api";

import CredentialsContext from "../contexts/CredentialsContext";

export default function EditUserForm(props) {
  const redirect = "/login";
  const {credentials, setCredentials} = useContext(CredentialsContext);
  const location = useLocation();
  const {state} = location;
  const [showPasswd, setShowPasswd] = useState(false);
  const [globalGameCheckBox, setGlobalGameCheckBox] = useState(false);
  const [gameCheckBoxState, setGameCheckBoxState] = useState(genCurrentGameCheckBoxArray(state.user.games));
  const [username, setUserName] = useState(state.user.username);
  const [password, setPassword] = useState("");
  const [passwordRep, setPasswordRep] = useState("");
  const [email, setEmail] = useState();
  const [role, setRole] = useState(state.user.usertype);
  const [dataError, setDataError] = useState();

  console.log(state.user);
  
  if (!credentials) {
    return <Navigate to={redirect} /> 
  }

  const editUserUIConfig = {
    title: "Редактирование существующего пользователя",
    login: "Введите новый логин",
    oldpasswd: "Введите новый пароль",
    passwd: "Введите новый пароль",
    passwdrep: "Повторите новый пароль",
    username: state.user.username,
    defusertype: state.user.usertype,
    btnvalue: "Сохранить"
  }

  let uiConfig = editUserUIConfig;

  const handleSubmit = async e => {
    e.preventDefault();

    let gameArray = [];
    gameCheckBoxState.forEach((elem, index) => {if(elem) gameArray.push(index)});

    const userCredentials = {
      mainUser: credentials.name,
      freshName: username,
      freshPassword: password,
      email,
      usertype: role,
      games: gameArray
    }

    if(username === ""){
      return setDataError("Поле «Логин» должно быть заполнено");
    }
    if(!/^[a-z0-9_/]+$/.test(username)){
      return setDataError("Поле «Логин» может содержать только строчные английские буквы или цифры");
    }
    if(password !== "" || passwordRep !== ""){
      if(password === ""){
        return setDataError("Поле «Пароль» должно быть заполнено");
      }
      else if(password.length <= 5){
        return setDataError("Пароль должен быть длиной не менее 6 символов");
      }
      else if(password !== passwordRep){
        return setDataError("Пароли не совпадают");
      }
      else if(!/^[a-z0-9~!@#$%^&*()/]+$/i.test(password)){
        return setDataError("Пароль может содержать только английские буквы и символы ~, !, @, #, $, %, ^, &, *, (, ), /");
      }
      else if(!/[A-Z]+/.test(password)){
        return setDataError("Пароль должен содержать хотя бы одну заглавную букву");
      }
      else if(!/[~!@#$%^&*()/]+/.test(password)){
        return setDataError("Пароль должен содержать хотя бы один символ ~, !, @, #, $, %, ^, &, *, (, ), /");
      }
    }
    

    try {

      const result = await api.users.update(userCredentials, state.user.username, credentials.token); 
      if (result === "ok") 
        setDataError(false);
      else 
        throw new Error()
    } catch (error) {
      if (error.match(/email .* already exists!/)) {
        setDataError(`Пользователь с указанным электронным адресом уже существует`);
        return;
      }
      if (error.match(/user .* already exists!/)) {
        setDataError(`Пользователь с указанным условным именем уже существует`);
        return;
      }
      if (error.match(/incorrect password/)) {
        setDataError(`Некорректный пароль`);
        return;
      }
      if (error.match(/User not found/)) {
        setDataError(`Редактируемый пользователь не найден`);
        return;
      }
      if (error.match(/incorrect email/)) {
        setDataError(`Некорректный электронный адрес`);
        return;
      }
      if (error.match(/Internal Server/)) {
        setDataError(`Во время обработки запроса произошла ошибка`);
        return;
      }
      setDataError("Ошибка во введённых данных");
    }
  }

  let gameNames = ["Теория государства и права", "Семейный совет", "Уголовный закон", "Криминология или профилактика преступности",
  "Экологический поход", "Основы юридической психологии", "Судебное исследование: фотография", "Основы кримтехники", "Наследование по закону"];

  const handleChange = (position) => {
    const updatedCheckedState = gameCheckBoxState.map((item, index) =>
      index === position ? !item : item
    );
    if(updatedCheckedState.includes(false)){
      setGlobalGameCheckBox(false);
    }
    setGameCheckBoxState(updatedCheckedState);
  }
   
  return (<>
  <Header backMode="/users"/>
  <div className="centering">
    <div className="loginpanel">
      <div className="title">{uiConfig.title}</div>
      { dataError &&
        <div style={{color: "red", textAlign: "center"}}>{dataError}</div>
      }
      { dataError === false &&
        <div>
          <p style={{ color: "green" }}>Пользователь успешно изменён</p>
        </div>
      }
      <form onSubmit={handleSubmit}>
        <label htmlFor="username">{uiConfig.login}</label>
        <input
          type="text"
          id="username"
          name="freshName"
          className="form-control"
          defaultValue={uiConfig.username}
          onChange={(e) => setUserName(e.target.value)}
          />
        <br />
        <label htmlFor="password">{uiConfig.passwd}</label>
        <input
          type={showPasswd ? "text" : "password"}
          id="password"
          name="freshPassword"
          className="form-control"
          onChange={(e) => setPassword(e.target.value)}
          />
        <br/>
        <label htmlFor="password">{uiConfig.passwdrep}</label>
        <input
          type={showPasswd ? "text" : "password"}
          id="password1"
          name="freshPassword"
          className="form-control"
          onChange={(e) => setPasswordRep(e.target.value)}
          />
        <br/>
        <div>
          <input type="checkbox" name="showpwd" onChange={() => setShowPasswd((p) => !p)}/>
          <label htmlFor="showpwd">Показать пароль</label>
        </div>
        <br/>
        <label htmlFor="role">Роль пользователя</label>
        <select id="role" name='usertype' className="form-control" defaultValue={uiConfig.defusertype} onChange={(e) => setRole(e.target.value)}>
          <option value="user">Пользователь</option>
          <option value="expert">Эксперт</option>
          <option value="developer">Разработчик</option>
        </select>
        <br/>
        <div>
          <h3 className="centering">Доступ к играм</h3>
          <div>
            <input type="checkbox" name="games" value="Все" checked={globalGameCheckBox} 
            onChange={() =>{gameCheckBoxState.fill(!globalGameCheckBox); setGlobalGameCheckBox(v => !v);}}/>
            <label htmlFor="games">Все</label>
          </div>
          {gameNames.map((elem, index) => <div key={elem}>
            <input type="checkbox" name="elem" value={index} checked={gameCheckBoxState[index]}
            onChange={() =>handleChange(index)}/>
            <label htmlFor="games">{elem}</label>
          </div>)}
        </div>
        <br/>
        <div className="centering">
          <input type="submit" disabled={!gameCheckBoxState.includes(true)} className="btn btn-success" value={uiConfig.btnvalue} />
        </div>
      </form>
    </div>
  </div>

  </>
  );
}

function genCurrentGameCheckBoxArray(stringArray){
  let array = JSON.parse(stringArray);
  if(!array) return Array(9).fill(false);
  return new Array(9).fill(false).map((elem, index) => array.includes(index));
}
